import useAuthorization from '@/composables/useAuthorization.js'

export default {
  install(app) {
    const { can, canAny, canAll, hasRole } = useAuthorization()

    app.directive('can', {
      mounted(el, binding) {
        if (!can(binding.value)) {
          el.remove()
        }
      },
      updated(el, binding) {
        if (!can(binding.value)) {
          el.remove()
        }
      },
    })

    app.directive('can-any', {
      mounted(el, binding) {
        if (!canAny(binding.value)) {
          el.remove()
        }
      },
      updated(el, binding) {
        if (!canAny(binding.value)) {
          el.remove()
        }
      },
    })

    app.directive('can-all', {
      mounted(el, binding) {
        if (!canAll(binding.value)) {
          el.remove()
        }
      },
      updated(el, binding) {
        if (!canAll(binding.value)) {
          el.remove()
        }
      },
    })

    app.config.globalProperties.$can = (permission) => {
      return can(permission)
    }
    app.config.globalProperties.$canAny = (permissions) => {
      return canAny(permissions)
    }
    app.config.globalProperties.$canAll = (permissions) => {
      return canAll(permissions)
    }
    app.config.globalProperties.$hasRole = (role) => {
      return hasRole(role)
    }
  },
}
